function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCloudLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Google_Cloud_logo",
    "data-name": "Google Cloud logo",
    viewBox: "0 0 138.35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M89.75,18.62A8.36,8.36,0,0,1,81.2,10,8.33,8.33,0,0,1,83.63,3.9a8.25,8.25,0,0,1,6.12-2.48,7.62,7.62,0,0,1,6,2.69L94.28,5.58a5.64,5.64,0,0,0-4.53-2.14,6.22,6.22,0,0,0-4.57,1.84A6.38,6.38,0,0,0,83.36,10a6.38,6.38,0,0,0,1.82,4.74,6.18,6.18,0,0,0,4.57,1.84,6.44,6.44,0,0,0,5-2.42l1.54,1.5a8,8,0,0,1-2.87,2.17A8.67,8.67,0,0,1,89.75,18.62ZM100.12,1.79V18.26H98V1.79Zm1.82,10.83a6,6,0,0,1,1.64-4.3,5.57,5.57,0,0,1,4.16-1.7,5.51,5.51,0,0,1,4.14,1.7,5.92,5.92,0,0,1,1.65,4.3,5.87,5.87,0,0,1-1.65,4.3,5.47,5.47,0,0,1-4.14,1.7,5.53,5.53,0,0,1-4.16-1.7A6,6,0,0,1,101.94,12.62Zm2.12,0a4.1,4.1,0,0,0,1.06,2.94,3.6,3.6,0,0,0,5.24,0,4.1,4.1,0,0,0,1.06-2.94,4.07,4.07,0,0,0-1.06-2.92,3.56,3.56,0,0,0-5.24,0A4.07,4.07,0,0,0,104.06,12.62Zm21.17,5.64h-2V16.69h-.1a3.75,3.75,0,0,1-1.48,1.38,4.23,4.23,0,0,1-2.08.55,4.18,4.18,0,0,1-3.19-1.18,4.74,4.74,0,0,1-1.11-3.37V7h2.11v6.94a2.49,2.49,0,0,0,2.79,2.76,2.63,2.63,0,0,0,2.11-1,3.69,3.69,0,0,0,.85-2.45V7h2.12Zm7.16.36a5,5,0,0,1-3.79-1.74A6.24,6.24,0,0,1,127,12.62a6.2,6.2,0,0,1,1.56-4.25,4.94,4.94,0,0,1,3.79-1.75,4.78,4.78,0,0,1,2.27.53,4,4,0,0,1,1.58,1.4h.09L136.24,7V1.79h2.11V18.26h-2V16.69h-.09a4,4,0,0,1-1.58,1.4A4.78,4.78,0,0,1,132.39,18.62Zm.35-1.93a3.21,3.21,0,0,0,2.55-1.13,4.17,4.17,0,0,0,1-2.94,4.21,4.21,0,0,0-1-2.92,3.23,3.23,0,0,0-2.55-1.15,3.29,3.29,0,0,0-2.55,1.15,4.21,4.21,0,0,0-1,2.92,4.14,4.14,0,0,0,1,2.92A3.29,3.29,0,0,0,132.74,16.69Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_75x24px",
    "data-name": "75x24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49,18.62A9.46,9.46,0,0,1,0,9.31,9.46,9.46,0,0,1,9.49,0,8.91,8.91,0,0,1,15.9,2.57L14.09,4.36a6.51,6.51,0,0,0-4.6-1.82A6.69,6.69,0,0,0,2.78,9.31a6.69,6.69,0,0,0,6.71,6.77,6.25,6.25,0,0,0,4.72-1.87A5.26,5.26,0,0,0,15.6,11H9.49V8.47h8.6a8.38,8.38,0,0,1,.13,1.59A8.37,8.37,0,0,1,16,16,8.57,8.57,0,0,1,9.49,18.62Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52,12.62a5.94,5.94,0,1,1-11.87,0,5.94,5.94,0,1,1,11.87,0Zm-2.6,0a3.35,3.35,0,1,0-6.67,0,3.35,3.35,0,1,0,6.67,0Z",
    style: {
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.83,12.62a5.94,5.94,0,1,1-11.87,0,5.94,5.94,0,1,1,11.87,0Zm-2.6,0a3.35,3.35,0,1,0-6.68,0,3.35,3.35,0,1,0,6.68,0Z",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8,7V17.76c0,4.42-2.63,6.24-5.73,6.24a5.75,5.75,0,0,1-5.34-3.54l2.31-1a3.32,3.32,0,0,0,3,2.14c2,0,3.22-1.23,3.22-3.52v-.86H55.2A4.16,4.16,0,0,1,52,18.62a6,6,0,0,1,0-12A4.22,4.22,0,0,1,55.2,8h.09V7Zm-2.33,5.66A3.39,3.39,0,0,0,52.25,9a3.48,3.48,0,0,0-3.35,3.66,3.45,3.45,0,0,0,3.35,3.61A3.35,3.35,0,0,0,55.47,12.65Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.43.64V18.26H59.79V.64Z",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.83,14.6,74.89,16a6,6,0,0,1-5,2.66,5.81,5.81,0,0,1-5.89-6,5.52,5.52,0,0,1,10.75-2.18l.27.69-8,3.31a3.07,3.07,0,0,0,2.92,1.82A3.44,3.44,0,0,0,72.83,14.6Zm-6.31-2.16,5.38-2.22A2.34,2.34,0,0,0,69.66,9,3.29,3.29,0,0,0,66.52,12.44Z",
    style: {
      fill: "#ea4335"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudLogo);
export default __webpack_public_path__ + "static/media/google-cloud-logo.a648fc726009aa782ad59b003b454f57.svg";
export { ForwardRef as ReactComponent };